import axios from './APIAxios';
import storage from '../storage';
import Api from "./APIAxios";


import { IAreaSupervisaoResponse, ICompaniesResponse, IFuncionariosListBody, IFuncionariosListResponse, ILocalBody, ILocalResponse, ITurnosResponse } from '../@interfaces';


const ApiGeral = {
  getFuncionariosList: async (body: IFuncionariosListBody): Promise<IFuncionariosListResponse> => {
    const url = storage.getClientUrl();
    try {
      const response = await Api.post<IFuncionariosListResponse>(`${url}/ListaFuncionarios`, body)

      if (response.data.status === 0) {
        return response.data
      }
      return { error: true, message: response.data.mensagem };
    } catch (e) {
      return { error: true, message: e };
    }
  },


  getPlacesList: async function (body: ILocalBody): Promise<ILocalResponse> {
		const url = storage.getClientUrl();
		try {
			const response = await Api.post<ILocalResponse>(`${url}/ListaLocal`, body);
			if (response.data.status !== 0) {
				return { error: true, message: response.data.mensagem }
			} else {
				return response.data;
			}

		} catch (e) {
			console.log(e);
			return { error: true, message: 'Algo deu errado' };
		}
	},

	getCompanies: async function (): Promise<ICompaniesResponse> {
		const url = storage.getClientUrl();
		try {
			const response = await Api.get<ICompaniesResponse>(`${url}/ListaEmpresas`);

			if ((response.data.status !== 0) && (response.data.status !== 127)) {
				return { error: true, message: response.data.mensagem }
			} else {
				return response.data;
			}

		} catch (e) {
			console.log(e);
			return { error: true, message: 'Algo deu errado' };
		}
	},

	getAreaSupervisao: async function (empresa: number): Promise<IAreaSupervisaoResponse> {
    const url = storage.getClientUrl();
    try {
    

      const response = await Api.post<IAreaSupervisaoResponse>(`${url}/areasSupervisao`, { empresa });
      if (response.data.status !== 0) {
        return { error: true, message: response.data.mensagem }
      } else {
        return response.data;
      }
    } catch (e) {
      console.log(e);
      return { error: true, message: 'Algo deu errado' };
    }
  },

  getTurnos: async function (): Promise<ITurnosResponse> {
    const url = storage.getClientUrl();
    try {
    

      const response = await Api.get<ITurnosResponse>(`${url}/turnos`);
      if (response.data.status !== 0) {
        return { error: true, message: response.data.mensagem }
      } else {
        return response.data;
      }
    } catch (e) {
      console.log(e);
      return { error: true, message: 'Algo deu errado' };
    }
  },
}

export default ApiGeral;